<template>
  <div>
    <b-form @submit.prevent="onSubmitForm">
      <create-information
        ref="setbannerInfo"
        :set-banner="setBannerData.setBanner"
      />
      <create-mapping-banner
        ref="mappingBanner"
        :display-key="bannerListTableConfig.displayKey"
        :query-id="bannerListTableConfig.queryId"
        :query-data-key="bannerListTableConfig.queryDataKey"
        :mapping-banner="setBannerData.mappingBanner"
        :loading="loading.createEditSetBanner"
        :set-banner-information="setBannerData.setBanner"
        @onCancel="resolveRedirect"
      />
      <b-col cols="12">
        <div class="content-mapping-action">
          <cancel-button class="mr-1" @click.native="resolveRedirect" />
          <save-button :type="'submit'" :loading="loading.createEditSetBanner" />
        </div>
      </b-col>
    </b-form>
  </div>
</template>

<script>
import { BForm, BSpinner, BButton } from 'bootstrap-vue'
import { getCurrentInstance } from '@vue/composition-api'
import CreateInformation from './CreateInformation.vue'
import CreateMappingBanner from './CreateMappingBanner.vue'

import useCreateSetBanner from '../hooks/useCreateSetBanner'

export default {
  components: {
    CreateInformation,
    CreateMappingBanner,
    BForm,
    BSpinner,
    BButton,
  },

  props: { isEdit: Boolean },

  setup(props) {
    const {
      bannerListTableConfig,
      setBannerData,
      loading,
      onSubmitForm,
      resolveRedirect,
    } = useCreateSetBanner(props)

    const vm = getCurrentInstance().proxy

    return {
      bannerListTableConfig,
      setBannerData,
      loading,
      onSubmitForm,
      resolveRedirect,
    }
  },
}
</script>

<style scoped>
@import '~@/assets/css/pages/banner/set-banner-form.css';
</style>
